/**
 * ELVET logo + wordmark loading state. No hooks or client APIs, so the same
 * markup can be rendered in the server HTML (first-load splash) and in
 * client loading fallbacks. Styles live in index.css (.brand-loader*).
 */
export const BrandLoader = ({ small = false, className }: { small?: boolean; className?: string }) => (
  // Plain string join: this renders in the server layout, and cn() is a client module.
  <div className={["brand-loader", small ? "brand-loader--sm" : "", className ?? ""].filter(Boolean).join(" ")} role="status" aria-live="polite">
    <div className="brand-loader__mark">
      <span className="brand-loader__ring" />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img className="brand-loader__logo" src="/elvet_logo.jpg" alt="" width={96} height={96} />
    </div>
    <div className="brand-loader__name">ELVET</div>
    <div className="brand-loader__tag">Elvet Clinic · 24/7</div>
    <div className="brand-loader__bar" />
    <span className="sr-only">Loading…</span>
  </div>
);

/** Centred loader for a page that is still fetching its code or data. */
export const PageLoader = () => (
  <div className="flex min-h-[70vh] items-center justify-center">
    <BrandLoader small />
  </div>
);

export default BrandLoader;
